var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38124 2.02896C3.38124 2.87889 2.74148 3.55895 1.71421 3.55895H1.69536C0.706332 3.55895 0.0668945 2.87889 0.0668945 2.02896C0.0668945 1.16105 0.725778 0.5 1.7336 0.5C2.74148 0.5 3.36212 1.16105 3.38124 2.02896ZM3.18717 4.76714V13.619H0.241095V4.76714H3.18717ZM13.8118 13.619L13.8119 8.54359C13.8119 5.82475 12.3585 4.5593 10.4198 4.5593C8.85565 4.5593 8.15533 5.41844 7.76436 6.02115V4.76741H4.81791C4.85674 5.598 4.81791 13.6192 4.81791 13.6192H7.76436V8.67559C7.76436 8.41104 7.78348 8.14714 7.86137 7.95772C8.0743 7.42922 8.55909 6.88203 9.373 6.88203C10.4395 6.88203 10.8658 7.69371 10.8658 8.88321V13.619H13.8118Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinVector);
export default __webpack_public_path__ + "static/media/linkedinVector.78aaad7afb912d6ecde0d0b5ef294557.svg";
export { ForwardRef as ReactComponent };